export default __webpack_public_path__ + "static/md-c946c092e085c52ba33eb4b82250d8f6.svg";